import PropTypes from 'prop-types';
import { useContext } from 'react';
import Helmet from 'react-helmet';
import { useSelector } from 'react-redux';
import {
  ACCOUNT_SETTINGS_PAGE_TITLE,
  DEVICES_PAGE_TITLE,
  GENERAL_PAGE_TITLE,
  SUBSCRIPTION_PAGE_TITLE,
} from 'src/common/constants/localizations/settings';
import { selectIsSubscriptionEnabled } from 'src/common/selectors/config';
import withAuthHandling from '../../decorators/auth/withAuthHandling';
import { LocationAndLocalizationContext } from '../../providers/LocationAndLocalizationProvider';
import commonCss from '../../styles/common.module.scss';
import unauthRedirectHandler from '../../utils/auth/unauthRedirectHandler';
import css from './account-settings.module.scss';
import DeviceSettings from './devices/DeviceSettings';
import GeneralSettings from './general/GeneralSettings';
import { devicesTab, generalTab, subscriptionTab } from './getLinks';
import Links from './Links';
import Subscription from './subscription';

const tabComponentMap = {
  [generalTab]: GeneralSettings,
  [devicesTab]: DeviceSettings,
  [subscriptionTab]: Subscription,
};

const tabPageTitleMap = {
  [generalTab]: GENERAL_PAGE_TITLE,
  [subscriptionTab]: SUBSCRIPTION_PAGE_TITLE,
  [devicesTab]: DEVICES_PAGE_TITLE,
};

const AccountSettings = ({ routeProps: { settingsTab } }) => {
  const { getLocalizedText } = useContext(LocationAndLocalizationContext);

  const SettingsTabComponent = tabComponentMap[settingsTab] || GeneralSettings;
  const pageTitle = tabPageTitleMap[settingsTab] || ACCOUNT_SETTINGS_PAGE_TITLE;

  const isSubscriptionEnabled = useSelector(selectIsSubscriptionEnabled);

  return (
    <div data-testid="accountSettings" className={commonCss.contentContainer}>
      <Helmet>
        <title>{getLocalizedText(pageTitle)}</title>
      </Helmet>
      <div className={css.largeSection}>
        <div className="row">
          <div className="col-xs-12">
            <h1 className={css.title}>{getLocalizedText(ACCOUNT_SETTINGS_PAGE_TITLE)}</h1>
          </div>
        </div>
      </div>
      <div className={css.largeSection}>
        <div className="row">
          <div className="col-xs-12">
            <Links selectedTab={settingsTab} showSubscriptionTab={isSubscriptionEnabled} />
          </div>
        </div>
      </div>
      <SettingsTabComponent />
    </div>
  );
};

AccountSettings.propTypes = {
  routeProps: PropTypes.shape({
    settingsTab: PropTypes.string.isRequired,
  }),
};

export default withAuthHandling({ unauthRedirectHandler })(AccountSettings);
